// import { retry } from "rxjs/operator/retry";

export default {
	authenticated: state => {
		return state.authenticated;
	},
	user: state => {
		return state.user;
	},
	authorized: state => {
		return state.authorized;
	},
	administrator: state => {
		return state.administrator;
	},
	token: state => {
		return state.token;
	},
	selectedPersonKey: state => {
		return state.selectedPersonKey;
	},
	selectedPersonVehicles: state => {
		return state.selectedPersonVehicles;
	},
	selectedPersonIsUser: state => {
		return state.selectedPersonIsUser;
	},
	people: state => {
		return state.people;
	},
	technology: state => {
		return state.technology;
	},
	skillsRatingByTechnology: state => {
		return state.skillsRatingByTechnology;
	},
	person: state => {
		return state.person;
	},
	selectedGroupKey: state => {
		return state.selectedGroupKey;
	},
	groups: state => {
		return state.groups;
	},
	selectedGroup: state => {
		return state.selectedGroup;
	},
	memberships: state => {
		return state.memberships;	
	},
	selectedGroupMembers: state => {
		return state.selectedGroupMembers;
	},
	selectedMemberKey: state => {
		return state.selectedMemberKey;
	},
	selectedMember: state => {
		return state.selectedMember;
	},
	selectedMemberships: state => {
		return state.selectedMemberships;
	},
	selectedSlackMember: state => {
		return state.selectedSlackMember;
	},
	selectedSlackMemberships: state => {
		return state.selectedSlackMemberships;
	},
	birthdaysThisMonth: state => {
		return state.birthdaysThisMonth;
	},
	anniversariesThisMonth: state => {
		return state.anniversariesThisMonth;
	},
	togglProjects: state => {
		return state.togglProjects;
	},
	projectsManagementOverview: state => {
		return state.projectsManagementOverview;
	},
	projectsManagementDetails: state => {
		return state.projectsManagementDetails;
	},
	selectedProjectKey: state => {
		return state.selectedProjectKey;
	},
	project: state => {
		return state.project;
	},
	skillsRatingByPerson: state => {
		return state.skillsRatingByPerson;
	},
	selectedPersonSkillsRating: state => {
		return state.selectedPersonSkillsRating;
	}
};



// WEBPACK FOOTER //
// ./src/store/getters.js